import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateCheckInfoAction as updateCheckInfo } from '../../../../../services/RefundService/slice';

const US_STATES = [
    'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
    'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
    'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
    'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
    'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
];

export const StateField: React.FC = () => {
    const dispatch = useAppDispatch();
    const { currentRefund } = useAppSelector(state => state.refund);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(updateCheckInfo({ state: event.target.value }));
    };

    return (
        <TextField
            label="State"
            select
            value={currentRefund?.checkInfo?.state || ''}
            onChange={handleChange}
            size="small"
            sx={{ flex: 1 }}
        >
            <MenuItem value="">
                <em>Select State</em>
            </MenuItem>
            {US_STATES.map((state) => (
                <MenuItem key={state} value={state}>
                    {state}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default StateField;
